import React, { useState, useEffect, useMemo } from "react";
import { groupBy } from "lodash";
import { toast } from "react-toastify";
import moment from "moment";
import {
  getPDFBytes,
  getDocusignTransactions,
  getClientCarePlans,
  getDocusignPDF,
} from "./services/soar";
import {
  sendForExternalSignatures,
  sendVoidRequest,
  resendEnvelope,
  getAuditHistory,
} from "./services/docusignService";
import {
  getFieldDate,
  getFieldName,
  updateEntity,
} from "../scripts/helperScripts";
import ExternalSignaturesModal from "./ExternalSignaturesModal";
import ExpandDiv from "./common/ExpandDiv";
import CarePlanComments from "./common/CarePlanComments";
import DocusignAuditHistory from "./forms/DocusignAuditHistory";

function CarePlans({ contactID, carePlans, updateCarePlans, clientProgram }) {
  const [pdfData, setPdfData] = useState(null);
  const [cpID, setCpID] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
  const [selectedCarePlan, setSelectedCarePlan] = useState();
  const [docusignTransactions, setDocusignTransactions] = useState(null);
  const [externalRecipients, setExternalRecipients] = useState(null);
  const [auditHistory, setAuditHistory] = useState({});
  const [auditIsOpen, setAuditIsOpen] = useState(false);
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  const dsorg =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "https://app.docusign.com"
      : "https://appdemo.docusign.com";

  useEffect(() => {
    getTransactions();
  }, [contactID]);

  useEffect(() => {
    if (
      pdfData !== null &&
      externalRecipients !== null &&
      externalRecipients.length > 0
    ) {
      sendToDocuSign();
    }
  }, [externalRecipients, pdfData]);

  const sendToDocuSign = async () => {
    const response = await sendForExternalSignatures(
      pdfData,
      cpID,
      `Care Plan for ${contactID}`,
      "Care Plan",
      "Care Plan Signatures Needed",
      `${clientProgram.ccx_programunit["@name"]} Care Plan for ${clientProgram["con.firstname"]} ${clientProgram["con.lastname"]}`,
      externalRecipients
    );
    setPdfData(null);
    setExternalRecipients(null);

    if (response && response.envelopeId) {
      toast.success("Sent to DocuSign for External Signtatures");
    } else {
      toast.error(
        "Error sending to DocuSign. Error Message:" + response.message
      );
    }
  };

  const resendDocusign = async (envelope) => {
    const resp = await resendEnvelope(envelope);
    console.log("Resend Response", resp);
    toast.success("Resent Envelope Emails");
  };

  const openInDocusign = (envelope) => {
    window.open(`${dsorg}/documents/details/${envelope.toLowerCase()}`);
  };

  const getVoidReason = () => {
    const reason = window.prompt(
      "Voiding cannot be undone and ALL documents in the Docusign envelope will be voided. All recipients will receive an email that documents will be voided. Please specify a reason for the void:"
    );
    if (reason === "") return getVoidReason();
    else return reason;
  };

  const voidEnvelope = async (envelope) => {
    const reason = getVoidReason();
    if (reason !== undefined && reason !== null) {
      const resp = sendVoidRequest(envelope, reason);
      if (!resp.errorCode) {
        toast.success("Void Sent");
      } else {
        toast.danger(`Voiding Error: ${resp.errorCode}`);
      }
    }
  };

  const openCarePlanReport = (cpID) => {
    // const url = `https://safyreports.azurewebsites.net/Reports/CarePlan/Default?db=${reportOrg}&i=${cpID
    //   .replaceAll("{", "")
    //   .replaceAll("}", "")}`;
    //   window.open(url);
    toast.success("Care Plan Report being generated. This may take a moment");
    getPDFBytes(cpID).then((response) => {
      const pdf = JSON.parse(response).PDFByteData;
      let blob = base64toBlob(pdf);
      window.open(URL.createObjectURL(blob));
    });
  };

  // {
  //   email: "hiebertc@safy.org",
  //   name: "Cameron Hiebert",
  //   title: "Supervisor",
  //   roleName: "Signature 1",
  //   recipientId: "1",
  // },

  const getPDFData = (cpID) => {
    setCpID(cpID);
    setExternalRecipients(null);
    setPdfData(null);
    setIsOpen(true);
    getPDFBytes(cpID).then((response) => {
      const pdf = JSON.parse(response).PDFByteData;
      setPdfData(pdf);
      //window.open(URL.createObjectURL(base64toBlob(pdfData)));
      // const signers = [
      //   {
      //     email: "hiebertc@safy.org",
      //     name: "Cameron Hiebert",
      //     title: "Supervisor",
      //     roleName: "Signature 1",
      //     recipientId: "1",
      //   },
      // ];
      // sendForExternalSignatures(
      //   pdfData,
      //   "Care Plan",
      //   "Care Plan Signatures Needed",
      //   "Testing external Signatures",
      //   signers
      // );
    });
  };

  const base64toBlob = (data) => {
    const bytes = atob(data);
    let length = bytes.length;
    let out = new Uint8Array(length);

    while (length--) {
      out[length] = bytes.charCodeAt(length);
    }

    return new Blob([out], { type: "application/pdf" });
  };

  const openCarePlan = () => {
    const url =
      process.env.REACT_APP_CAREPLAN +
      "/dist/CarePlanPortal/index.html?contactid=" +
      contactID;
    window.open(url);
  };

  const openDocusignCertificate = (envelope) => {
    getDocusignPDF(envelope).then((response) => {
      if (response) {
        const pdfTransaction = JSON.parse(response);
        console.log("pdfTransaction", pdfTransaction);
        if (
          pdfTransaction.Docusign &&
          pdfTransaction.Docusign.Documents &&
          pdfTransaction.Docusign.Documents[0] &&
          pdfTransaction.Docusign.Documents[0].jsonData
        ) {
          const pdfJSON = JSON.parse(
            pdfTransaction.Docusign.Documents[0].jsonData
          );
          if (
            pdfJSON &&
            pdfJSON.envelopeDocuments &&
            pdfJSON.envelopeDocuments[pdfJSON.envelopeDocuments.length - 1]
              .PDFBytes
          ) {
            const pdfBytes =
              pdfJSON.envelopeDocuments[pdfJSON.envelopeDocuments.length - 1]
                .PDFBytes;
            console.log(pdfBytes);
            window.open(URL.createObjectURL(base64toBlob(pdfBytes)));
          } else alert("No PDF data return in Docusign response");
        } else alert("Invalid Docusign data returned");
      } else alert("Invalid Docusign PDF response receieved");
    });
  };

  const openDocusignHistory = (envelope) => {
    setAuditHistory({});
    getAuditHistory(envelope).then((resp) => {
      if (!resp.errorCode) {
        setAuditHistory(resp);
        setAuditIsOpen(true);
      } else {
        toast.error(`Error accessing Docusign History: ${resp.errorCode}`);
      }
    });
  };

  const getTransactions = async () => {
    let transactions = [];
    await getClientCarePlans(contactID).then((response) => {
      const clientCarePlans = response;
      clientCarePlans.forEach((careplan) => {
        getDocusignTransactions(
          careplan.ccx_careplanid.replaceAll("{", "").replaceAll("}", "")
        ).then((response) => {
          if (response) {
            let grouped = groupBy(
              response.sort((a, b) => parseInt(b.logId) - parseInt(a.logId)),
              "envelopeId"
            );
            transactions[careplan.ccx_careplanid] = grouped;
          }
          setDocusignTransactions(transactions);
          console.log("Transactions", transactions);
        });
      });
    });
  };

  const getExternalSignatures = (id) => {
    const transactions = docusignTransactions[id];
    return transactions && Object.values(transactions).length > 0 ? (
      <ExpandDiv
        title={
          <div className="d-inline small .fw-normal">
            <div className="d-inline rounded bg-danger px-2 me-2">
              {Object.values(transactions).length}
            </div>
            External Signature Requests
          </div>
        }
        expandIcon="fas fa-chevron-down text-warning me-1"
        collapseIcon="fas fa-chevron-up text-warning me-1"
      >
        {Object.values(transactions).map((t, index) => (
          <div
            className="row rounded m-2 p-2 bg-warning text-dark"
            key={`transaction${index}`}
          >
            <div className="col-5" title={t[0].envelopeId}>
              <div>Envelope created</div>
              <div>
                {`${moment
                  .utc(t[0].initialSentDateTime)
                  .local()
                  .format("MMM D, YYYY [at] h:mm A")}`}
              </div>
            </div>
            <div className="col-5">
              <div>{`Envelope ${t[0].status}`}</div>
              <div>
                {moment
                  .utc(t[0].statusChangedDateTime)
                  .local()
                  .format("MMM D, YYYY [at] h:mm A")}
              </div>
            </div>
            <div className="col-2 text-primary float-end">
              {t[0].status !== "voided" && (
                <>
                  <i
                    title="Void"
                    className="far fa-times-circle text-danger ps-2 float-end"
                    onClick={() => {
                      voidEnvelope(t[0].envelopeId);
                    }}
                  ></i>
                  <i
                    title="Docusign Certificate"
                    className="fas fa-history float-end me-2"
                    onClick={() => openDocusignCertificate(t[0].envelopeId)}
                  ></i>
                </>
              )}
              {t[0].status !== "completed" && t[0].status !== "voided" && (
                <>
                  <i
                    title="Resend"
                    className="far fa-envelope ps-2 float-end"
                    onClick={() => {
                      resendDocusign(JSON.parse(t[0].jsonData));
                      //DO Something else
                    }}
                  ></i>
                  <i
                    title="Open in Docusign"
                    className="far fa-eye float-end ps-2"
                    onClick={() => {
                      openInDocusign(t[0].envelopeId);
                      //DO Something else
                    }}
                  ></i>

                  <i
                    title="Audit History"
                    className="fas fa-history float-end"
                    onClick={() => openDocusignHistory(t[0].envelopeId)}
                  ></i>
                </>
              )}
              {/* {t[0].status === "completed" && (
                <i
                  className="fas fa-file-pdf"
                  onClick={() => openDocusignPDF(t[0].envelopeId)}
                />
              )} */}

              {t[0].status === "voided" && (
                <small className="text-danger float-end">
                  {JSON.parse(t[0].jsonData).voidedReason}
                </small>
              )}
            </div>
            <div className="rounded bg-light ps-4 mt-2">
              {JSON.parse(
                t.findLast((element) => element).jsonData
              ).recipients.signers.map((obj, index2) => (
                <div className="row" key={`t-${index}-${index2}`}>
                  <div className="col-4">{obj.name}</div>
                  <div className="col-3">{obj.email}</div>
                  <div className="col-2">
                    {JSON.parse(t[0].jsonData).recipients.signers.find(
                      (s) => s.recipientId === obj.recipientId
                    )?.status || "autocompleted"}
                  </div>
                  <div className="col-3">
                    {JSON.parse(t[0].jsonData).recipients.signers.find(
                      (s) => s.recipientId === obj.recipientId
                    )?.signedDateTime
                      ? moment
                          .utc(
                            JSON.parse(t[0].jsonData).recipients.signers.find(
                              (s) => s.recipientId === obj.recipientId
                            )?.signedDateTime
                          )
                          .local()
                          .format("MMM D, YYYY [at] h:mm A")
                      : null}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </ExpandDiv>
    ) : null;
  };

  const carePlanName = (cp) => {
    switch (getFieldName(cp.ccx_careplan_status)) {
      case "Draft in Progress":
        return <div>Draft in Progress</div>;
      case "Active":
        return (
          <div>
            <div>
              Active - {getFieldName(cp.ccx_careplan_type)} - Effective{" "}
              {getFieldDate(cp.ccx_effectivedate)}
            </div>
            <div>
              Next Review Due Date:{" "}
              {cp.ccx_nextreviewdate
                ? getFieldDate(cp.ccx_nextreviewdate)
                : "N/A"}
            </div>
            {docusignTransactions && getExternalSignatures(cp.ccx_careplanid)}
          </div>
        );
      default:
        return (
          <div>
            {getFieldName(cp.ccx_careplan_status)} -{" "}
            {getFieldName(cp.ccx_careplan_type)}{" "}
            {cp.ccx_effectivedate
              ? getFieldDate(cp.ccx_effectivedate) + "-"
              : ""}
            {cp.ccx_expirationdate ? getFieldDate(cp.ccx_expirationdate) : ""}
            {docusignTransactions && getExternalSignatures(cp.ccx_careplanid)}
          </div>
        );
    }
  };

  const carePlanStatus = (cp) => {
    switch (getFieldName(cp.ccx_careplan_status)) {
      case "Draft in Progress":
        return "p-2 m-2 text-white bg-safy3-50 row";
      case "Draft Shared":
        return "p-2 m-2 text-white bg-safy3-50 row";
      case "Active":
        return "p-2 text-white bg-safy3-1 row";
      case "Historical":
        return "p-2 m-2 text-white bg-safy3-1 row";
      default:
        return "p-2 m-2 text-white bg-safy3-1 row";
    }
  };

  const openCommentModal = (carePlan) => {
    setSelectedCarePlan(carePlan);
    setIsCommentsModalOpen(true);
  };

  const closeCommentModal = () => {
    setIsCommentsModalOpen(false);
    setSelectedCarePlan(undefined);
  };

  const selectedCarePlanComments = useMemo(() => {
    if (!selectedCarePlan?.sor_careplancomments) {
      return [
        {
          CreatedBy: safyInfo.user.domainName.replace("safy\\", ""),
          CreatedOn: new Date(),
          IsEditable: true,
        },
      ];
    }

    const comments = JSON.parse(selectedCarePlan.sor_careplancomments);

    if (comments.length === 0) {
      return [
        {
          CreatedBy: safyInfo.user.domainName.replace("safy\\", ""),
          CreatedOn: new Date(),
          IsEditable: true,
        },
      ];
    }

    return comments;
  }, [selectedCarePlan]);

  const handleCommentsChange = async (comments) => {
    const obj = { ...selectedCarePlan };
    obj.sor_careplancomments = JSON.stringify(comments);
    setSelectedCarePlan(obj);

    const saveObj = {
      sor_careplancomments: { type: "string", value: obj.sor_careplancomments },
    };

    await updateEntity(
      "ccx_careplan",
      obj.ccx_careplanid,
      JSON.stringify(saveObj),
      safyInfo
    );

    updateCarePlans(true);
  };

  const handleCommentsSave = (comments) => {
    comments.forEach((comment) => (comment.IsEditable = false));
    handleCommentsChange(comments);
    setIsCommentsModalOpen(false);
    setSelectedCarePlan(undefined);
  };

  // const openDocusignPDF = async (id) => {
  //   //alert(id);
  //   getDocusignPDF(id).then((response) => {
  //     if (response) {
  //       const pdfTransaction = JSON.parse(response);
  //       if (
  //         pdfTransaction.Docusign &&
  //         pdfTransaction.Docusign.Documents &&
  //         pdfTransaction.Docusign.Documents[0] &&
  //         pdfTransaction.Docusign.Documents[0].jsonData
  //       ) {
  //         const pdfJSON = JSON.parse(
  //           pdfTransaction.Docusign.Documents[0].jsonData
  //         );
  //         if ( b
  //           pdfJSON &&
  //           pdfJSON.envelopeDocuments &&
  //           pdfJSON.envelopeDocuments[1].PDFBytes
  //         ) {
  //           let blob = base64toBlob(pdfJSON.envelopeDocuments[1].PDFBytes);
  //           //blob += base64toBlob(pdfJSON.envelopeDocuments[0].PDFBytes);
  //           window.open(URL.createObjectURL(blob));
  //         } else alert("No PDF data return in Docusign response");
  //       } else alert("Invalid Docusign data returned");
  //     } else alert("Invalid Docusign PDF response receieved");
  //   });
  // };

  return (
    <div>
      {isOpen ? (
        <ExternalSignaturesModal
          isOpen={isOpen}
          closeModal={() => setIsOpen(false)}
          contactId={contactID}
          handleSetRecipients={setExternalRecipients}
        />
      ) : null}
      <DocusignAuditHistory
        auditEvents={auditHistory}
        isOpen={auditIsOpen}
        hideModal={() => setAuditIsOpen(!auditIsOpen)}
      ></DocusignAuditHistory>
      <div className="border p-4 mb-4 card-safy">
        <div className="h3 mb-4">
          Care Plan
          <i
            title="Edit"
            onClick={() => openCarePlan()}
            className="fas fa-pen float-end p-1"
          ></i>
        </div>
        {carePlans.length > 0 &&
          carePlans.map((cp, index) => (
            <>
              <div className={carePlanStatus(cp)} key={cp.ccx_careplanid}>
                <div className="col-10">{carePlanName(cp)}</div>
                <div className="col-2">
                  <div className="float-end">
                    <i
                      title="Send for External Signatures"
                      onClick={() =>
                        getPDFData(
                          cp.ccx_careplanid
                            .toString()
                            .replaceAll("{", "")
                            .replaceAll("}", "")
                        )
                      }
                      className="fas fa-file-signature float-end p-1 text-white"
                    ></i>
                    <i
                      title="Report"
                      onClick={() =>
                        openCarePlanReport(
                          cp.ccx_careplanid
                            .toString()
                            .replaceAll("{", "")
                            .replaceAll("}", "")
                        )
                      }
                      className="fas fa-print float-end p-1 text-white"
                    ></i>
                    <i
                      title="Comment"
                      onClick={() => openCommentModal(cp)}
                      className={`fas fa-comment-alt float-end p-1 ${
                        cp.sor_careplancomments &&
                        JSON.parse(cp.sor_careplancomments).length > 0
                          ? "text-warning"
                          : "text-white"
                      }`}
                    ></i>
                  </div>
                </div>
              </div>
              {isCommentsModalOpen &&
              selectedCarePlan.ccx_careplanid === cp.ccx_careplanid ? (
                <CarePlanComments
                  isOpen={isCommentsModalOpen}
                  comments={selectedCarePlanComments}
                  carePlanIndex={index}
                  handleChange={handleCommentsChange}
                  handleSave={handleCommentsSave}
                  handleClose={closeCommentModal}
                />
              ) : null}
            </>
          ))}
      </div>
    </div>
  );
}

export default CarePlans;
